import { signal } from "@preact/signals";

export interface Product {
  sku: string;
  isSelected: boolean;
  quantity: number;
  seller?: string;
}

const selectedProducts = signal([] as Product[]);

const addProduct = (
  sku: string,
  isSelected: boolean,
  quantity: number,
  seller?: string,
) => {
  selectedProducts.value = [
    ...selectedProducts.value,
    {
      sku,
      isSelected,
      quantity,
      seller,
    },
  ];
};

const updateProductSelection = (sku: string, isSelected: boolean) => {
  selectedProducts.value = selectedProducts.value.map((p) => {
    if (p.sku === sku) {
      p.isSelected = isSelected;
    }
    return p;
  });
};

const handleSelect = (
  sku: string,
  isSelected: boolean,
  seller?: string,
) => {
  const productIndex = selectedProducts.value.findIndex((p) => p.sku === sku);

  if (productIndex === -1) {
    addProduct(sku, isSelected, 1, seller);
  } else {
    updateProductSelection(sku, isSelected);
  }
};

const handleQuantity = (sku: string, quantity: number) => {
  const product = selectedProducts.value.find((p) => p.sku === sku);
  const newQuantity = quantity === 0 ? 1 : quantity;

  if (!product) {
    addProduct(sku, false, newQuantity);
  } else {
    selectedProducts.value = selectedProducts.value.map((p) => {
      if (p.sku === sku) {
        p.quantity = newQuantity;
      }
      return p;
    });
  }
};

const state = {
  selectedProducts,
  handleSelect,
  handleQuantity,
};

export const useProductSelector = () => state;
